/** @jsxImportSource @emotion/react */
import { clientNameAtom } from '@app/state/clientsAtom'
import { generateLogoUrls } from '@app/utils/generateLogoUrls'
import { useAtomValue } from 'jotai'
import { useMemo } from 'react'
import { useTheme } from '@mui/material'
import { selectedStoryAtom } from '@app/services/storiesService'
import { brandedTopBarBlock, rexLogo, clientLogo } from './PublicRiskStoriesBrandedTopBar.style'
import { PUBLIC_ASSETS_BASE_URL } from '@app/app-constants'

const PublicRiskStoriesBrandedTopBar = () => {
  const theme = useTheme()
  const clientName = useAtomValue(clientNameAtom)
  const story = useAtomValue(selectedStoryAtom)

  const logos = useMemo(() => generateLogoUrls(clientName), [clientName])

  if (story instanceof Error) return null

  return (
    <div css={brandedTopBarBlock({ theme, branding: story?.branding })}>
      <img
        src={`${PUBLIC_ASSETS_BASE_URL}/images/shared/new_RexLogoFull.svg`}
        alt="Logo"
        css={rexLogo(theme)}
      />
      {story?.title}
      <a href="https://resilience-explorer.org" target="_blank" rel="noreferrer">
        <img src={logos.whiteFull} alt="Logo" css={clientLogo(theme)} />
      </a>
    </div>
  )
}

export default PublicRiskStoriesBrandedTopBar
